<template>
  <div class="partners-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="600"
            :mask-closable="false"
            :styles="styles">
      <Form :model="agents"
            :label-width="60">
        <Card style="width:100%"
              v-for="(item, index) in agents.detail"
              :key="index">
          <Row>
            <Col :span="24">
            <div style="font-size: large;margin-bottom: 10px;">{{ item.name }}</div>
            </Col>
          </Row>
          <template #extra>
            <div style="display: flex; align-items: center; min-height: 30px; margin-bottom: 10px;"
                 v-if="item.editable == 1">
              <!-- 输入框 -->
              <input v-if="item.editable == 1 && item.edit_type == 2"
                     v-model="item.input_value" />
              <!-- 多行输入框 -->
              <input v-if="item.editable == 1 && item.edit_type == 1"
                     type="textarea"
                     v-model="item.input_value" />
              <!-- 单选 -->
              <radio-group v-model="item.input_value"
                           v-else-if="item.editable == 1 && item.edit_type == 3">
                <radio v-for="(op, o) in item.options"
                       :key="o"
                       :label="op.value">{{ op.value
                                    }}
                  <input v-if="op.is_shuru == '1'"
                         v-model="op.text" />
                </radio>
              </radio-group>
              <!-- 日期 -->
              <date-picker v-model="item.input_value"
                           v-else-if="item.editable == 1 && item.edit_type == 4"
                           value-format="yyyy-MM-dd"
                           type="date"
                           placeholder="请选择时间"
                           style="width:260px;">
              </date-picker>
              <!-- 多选 -->
              <checkbox-group v-model="item.input_value"
                              v-else-if="item.editable == 1 && item.edit_type == 5">
                <checkbox v-for="(op, o) in item.options"
                          :key="o"
                          :label="op.value">{{ op.value }}
                  <input v-if="op.is_shuru == '1'"
                         v-model="op.text" />
                </checkbox>
              </checkbox-group>
              <!-- 区域 -->
              <FormItem label="地区"
                        v-else-if="item.editable == 1 && item.edit_type == 6 && item.select_biaoshi == 'AREA'">
                <select v-model="danwei.area1"
                        filterable
                        clearable
                        placeholder="请选择省"
                        @change="XiangChange">
                  <option v-for="(item, index) in shengList"
                          :key="index"
                          :label="item.areaname"
                          :value="item.id" />
                </select>
                <select v-model="danwei.area2"
                        filterable
                        clearable
                        placeholder="请选择市"
                        @change="CunChange">
                  <option v-for="(item, index) in shiList"
                          :key="index"
                          :label="item.areaname"
                          :value="item.id" />
                </select>
                <select v-model="danwei.area3"
                        filterable
                        clearable
                        placeholder="请选择县">
                  <option v-for="(item, index) in quList"
                          :key="index"
                          :label="item.areaname"
                          :value="item.id" />
                </select>
              </FormItem>
            </div>
            <div style="display: flex; align-items: center; min-height: 30px; margin-bottom: 10px;"
                 v-if="item.editable == 0 && item.children.length > 0">
              <div style="margin-left: 20px;"
                   v-for="(child, j) in item.children"
                   :key="j">
                <div style="font-size: medium;margin-left: 10px;min-width: 100px;">{{ child.name }}
                </div>
                <input v-if="child.editable == 1 && child.edit_type == 2"
                       v-model="child.input_value" />
                <input v-if="child.editable == 1 && child.edit_type == 1"
                       type="textarea"
                       v-model="child.input_value" />
                <radio-group v-model="child.input_value"
                             v-else-if="child.editable == 1 && child.edit_type == 3">
                  <radio v-for="(op, o) in child.options"
                         :key="o"
                         :label="op.value">{{ op.value
                                        }}</radio>
                </radio-group>
                <date-picker v-model="child.input_value"
                             v-else-if="child.editable == 1 && child.edit_type == 4"
                             value-format="yyyy-MM-dd"
                             type="date"
                             placeholder="请选择时间"
                             style="width:260px;">
                </date-picker>
                <checkbox-group v-model="child.input_value"
                                v-else-if="child.editable == 1 && child.edit_type == 5">
                  <checkbox v-for="(op, o) in child.options"
                            :key="o"
                            :label="op.value">{{ op.value
                                        }}</checkbox>
                </checkbox-group>

              </div>
            </div>
          </template>

        </Card>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editagent()">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
  
  <script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
export default {
  name: "partners-list",
  data () {
    return {
      //抽屉参数
      value3: false,
      isable: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      isClear: false,
      loading: true,
      dataloading: true,
      imagefacethumblist: [], // 身份证是正面
      imagebackthumblist: [], // 身份证反面
      thumblist: [], // 营业执照
      cates: [],
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          minwidth: 200,
        },
        {
          title: "电话",
          key: "phone",
          minwidth: 200,
        },
        {
          title: "昵称",
          key: "nickname",
          minwidth: 200,
        },
        {
          title: "名称",
          key: "name",
          minwidth: 200,
        },
        {
          title: "同步时间",
          key: "created_at",
          minwidth: 150
        },
        {
          title: "操作",
          key: "action",
          width: 400,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),

            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      agents: {
        id: null,
        nickname: "",
        phone: "",
        name: "",
        status: "0",
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      },
      status: 1,
    };
  },
  created: function () {
    this.getTableList();
  },
  components: {
    UploadThumb,
    // EditorBar,
    uploadthumbTwo
  },
  methods: {
    getTableList: function () {
      this.$api.tradesman
        .gongjianglist({
          page: this.pages.page,
          size: this.pages.size,
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    getXianList (index) {
      this.$api.intangibleItem.areaList({ id: 0 }).then((res) => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    XiangChange (value, index) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then((res) => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    CunChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then((res) => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    },
    // 详情
    async detail (index) {
      await this.getXianList();
      this.agents = {
        id: null,
        nickname: "",
        phone: "",
        name: "",
        type: 0,
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      };
      this.showModalStatus = !this.showModalStatus;
      this.agents.log_id = index;
      this.$api.tradesman.gongjiangdetail({ id: index }).then(async res => {
        if (res.result.area1 > 0) {
          await this.XiangChange(res.result.area1, 2);
          await this.CunChange(res.result.area2);
        }
        // this.danwei = res.result;
        let list = res.result;
        for (var i in list.detail) {
          if (!list.detail[i].input_value) {
            if (list.detail[i].edit_type == 3) {
              list.detail[i].input_value = ""
            } else if (list.detail[i].edit_type == 5) {
              list.detail[i].input_value = []
            }
          }
        }
        this.agents = list;
      });
    },
    // 修改
    editagent (name) {
      this.loading = false;
      this.$api.tradesman.editgongjiang({ form: this.agents }).then(res => {
        if (res.code == 200) {
          this.loading = true;
          this.getTableList();
        }
        this.showModalStatus = !this.showModalStatus;
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.tradesman.gongjianglist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].phone = this.tablelist[i].data.phone;
            this.tablelist[i].auth_company = this.tablelist[
              i
            ].data.auth_company;
            this.tablelist[i].is_undeline =
              this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
  </script>
  
  <style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
  